/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown> }} Billing_Seat_Change_DetailInputs */



/**
* | output |
* | --- |
* | "{from} → {to} seats" |
*
* @param {Billing_Seat_Change_DetailInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const billing_seat_change_detail = /** @type {((inputs: Billing_Seat_Change_DetailInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Seat_Change_DetailInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.from} → ${i?.to} Plätze`)
	return /** @type {LocalizedString} */ (`${i?.from} → ${i?.to} seats`)
});